import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TransactionTypesListComponent } from './transaction-types-list/transaction-types-list.component';
import { FormsModule } from '@angular/forms';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { ButtonModule } from 'primeng/button';
import { CardModule } from 'primeng/card';
import { CheckboxModule } from 'primeng/checkbox';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { DialogModule } from 'primeng/dialog';
import { DropdownModule } from 'primeng/dropdown';
import { InputTextareaModule } from 'primeng/inputtextarea';
import { SplitButtonModule } from 'primeng/splitbutton';
import { TableModule } from 'primeng/table';
import { TimelineModule } from 'primeng/timeline';
import { CalendarModule } from 'src/app/calendar/calendar.module';
import { CoreModule } from 'src/app/core/core.module';
import { TransactionTypesDetailComponent } from './transaction-types-detail/transaction-types-detail.component';
import { AppRoutingModule } from 'src/app/app-routing.module';



@NgModule({
  declarations: [TransactionTypesListComponent, TransactionTypesDetailComponent],
  imports: [
    CommonModule,
    ButtonModule,
    TableModule,
    ConfirmDialogModule,
    DialogModule,
    FormsModule,
    CheckboxModule,
    CoreModule,
    CardModule,
    FontAwesomeModule,
    InputTextareaModule,
    DropdownModule,
    CalendarModule,
    SplitButtonModule,
    TimelineModule,
    AppRoutingModule
  ],
  exports:[
    TransactionTypesListComponent
  ]
})
export class TransactionTypesModule { }
